import React, { useEffect, useState } from 'react'
import { Route, Switch, useHistory } from 'react-router-dom'

import './styles/styles.scss'
/* import Home, { path as homePath } from './pages/home'
import Locations, { path as locationsPath } from './pages/locations'
import Location, { path as locationPath } from './pages/location'
import Settings, { path as settingsPath } from './pages/settings'
import Fade, { path as fadePath } from './pages/fade'
import Logo, { path as logoPath } from './pages/logo' */

import Brandbook, { path as brandbookPath } from './pages/brandbook'
import BrandbookBrandStrategy, { path as BrandbookBrandStrategyPath } from './pages/brandbook/brand-strategy'
import BrandbookLogo, { path as BrandbookLogoPath } from './pages/brandbook/logo'
import BrandbookColors, { path as BrandbookColorsPath } from './pages/brandbook/colors'
import BrandbookTypography, { path as BrandbookTypographyPath } from './pages/brandbook/typography'
import BrandbookIcons, { path as BrandbookIconsPath } from './pages/brandbook/icons'
import BrandbookGrid, { path as BrandbookGridPath } from './pages/brandbook/grid'
import BrandbookImagery, { path as BrandbookImageryPath } from './pages/brandbook/imagery'
import BrandbookToneOfVoice, { path as BrandbookToneOfVoicePath } from './pages/brandbook/tone-of-voice'
import BrandbookProduct, { path as BrandbookProductPath } from './pages/brandbook/product'

import Error404 from './pages/404'
import { ParallaxProvider } from 'react-scroll-parallax'
import ModalWrapper from './components/ModalWrapper'
import ScrollToTop from './components/ScrollToTop'
import useVirtualPageview from './hooks/virtualPageview'

export default function App() {
  useVirtualPageview()

  return (
    <ModalWrapper>
        <ParallaxProvider>
            {/*<Header />*/}
            <ScrollToTop>
              <Switch>
                {/* <Route exact path={homePath} component={Home} />
                <Route exact path={locationsPath} component={Locations} />
                <Route exact path={locationPath} component={Location} />
                <Route exact path={settingsPath} component={Settings} />
                <Route exact path={fadePath} component={Fade} />
                <Route exact path={logoPath} component={Logo} /> */}

                <Route exact path={brandbookPath} component={Brandbook} />
                <Route exact path={BrandbookBrandStrategyPath} component={BrandbookBrandStrategy} />
                <Route exact path={BrandbookLogoPath} component={BrandbookLogo} />
                <Route exact path={BrandbookColorsPath} component={BrandbookColors} />
                <Route exact path={BrandbookTypographyPath} component={BrandbookTypography} />
                <Route exact path={BrandbookIconsPath} component={BrandbookIcons} />
                <Route exact path={BrandbookGridPath} component={BrandbookGrid} />
                <Route exact path={BrandbookImageryPath} component={BrandbookImagery} />
                <Route exact path={BrandbookToneOfVoicePath} component={BrandbookToneOfVoice} />
                <Route exact path={BrandbookProductPath} component={BrandbookProduct} />
                <Route exact path={'/'} component={Brandbook} />

                <Route component={Error404} />
              </Switch>
            </ScrollToTop>
        </ParallaxProvider>
    </ModalWrapper>
  )
}
